<template>
<div class="contact-box">

    <form method="post" @submit.prevent="onSubmit" :action="action" novalidate>

        <div class="alert alert-danger" v-if="error">
            <span v-html="error"></span>

        </div>

        <div class="row">
            <div class="col-lg-6">

                <div class="form-group row">
                    <div class="col-lg-12">
                        <label class="question" for="">{{__('__JSON__.Miben segíthetünk?')}}</label>
                        <div class="col-lg-12" v-for="(item, index) in radio1" :key="index">
                            <label class="form-check-label">
                                <input type="radio" :value="item" :class="{'form-check': true, 'is-danger': errors.has('radio1') }" v-validate="'required'" v-model="form.miben" />
                                {{ item }}
                            </label>
                        </div>
                    </div>
                </div>
                <div class="form-group row">
                    <div class="col-lg-12">&nbsp;

                    </div>

                    <div class="col-lg-9">
                        <label class="question" for="">{{__('__JSON__.Milyen forgalommal számoljunk?')}}</label>
                        <input type="text" name="forgalom" :class="{'form-control': true, 'is-danger': errors.has('forgalom') }" v-validate="'required|min:5'" placeholder="Felhasznált kávé mennyisége, vagy adag." v-model="form.forgalom">
                    </div>

                </div>
            </div>
            <div class="col-lg-6">
                <div class="form-group row">
                    <div class="col-lg-6">
                        <label class="question" for="">{{__('__JSON__.Vezetéknév')}}</label>
                        <input type="text" name="first_name" :class="{'form-control': true, 'is-danger': errors.has('first_name') }" v-validate="'required|max:50'" v-model="form.first_name"  >
                        <div v-show="errors.has('first_name')" class="help is-danger">@{{ errors.first('first_name') }}</div>
                    </div>

                    <div class="col-lg-6">
                        <label class="question" for="">{{__('__JSON__.Keresztnév')}}</label>
                        <input type="text" name="last_name" :class="{'form-control': true, 'is-danger': errors.has('last_name') }" v-validate="'required|max:50'" v-model="form.last_name"  >
                        <div v-show="errors.has('last_name')" class="help is-danger">@{{ errors.first('last_name') }}</div>
                    </div>
                </div>
                <div class="form-group row">
                    <div class="col-lg-12">
                        <label class="question" for="">{{__('__JSON__.E-Mail')}}</label>
                        <input type="text" name="email" :class="{'form-control': true, 'is-danger': errors.has('email') }" v-validate="'required|email|max:250'" v-model="form.email">
                        <div v-show="errors.has('email')" class="help is-danger">@{{ errors.first('email') }}</div>
                    </div>
                </div>
                <div class="form-group row">
                    <div class="col-lg-6">
                        <label class="question" for="">{{__('__JSON__.Telefon')}}</label>
                        <input type="text" name="phone" :class="{'form-control': true, 'is-danger': errors.has('phone') }" v-validate="'required|max:50'" v-model="form.phone">
                        <div v-show="errors.has('phone')" class="help is-danger">@{{ errors.first('phone') }}</div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-lg-12">
                <div class="form-group row">
                    <div class="col-lg-12">
                        <label class="question" for="">{{__('__JSON__.Üzenet')}}</label>
                        <textarea name="message" :class="{'form-control': true, 'is-danger': errors.has('message') }" v-validate="'required'" v-model="form.message"> </textarea>
                        <div v-show="errors.has('message')" class="help is-danger">@{{ errors.first('message') }}</div>
                    </div>
                </div>

            </div>
        </div>
        <div class="row">
            <div class="col-lg-12">
                <label class="form-check-label" for="is_privacy">

                    <input type='checkbox' name='is_privacy' v-model='form.is_privacy'>
                    <span v-html="elfogadom2"></span>.
                </label>
            </div>
        </div>

        <div class="form-group row mt-4">
            <div class="col-lg-12">
                <button v-if="form.is_privacy && !loading  && !success" type="button" name="button" class="btn btn-primary" @click="send">{{__('__JSON__.Üzenet elküldése')}}</button>
                <button v-if="!form.is_privacy && !loading  && !success" type="button" name="button" class="btn btn-disabled">{{__('__JSON__.Üzenet elküldése')}}</button>
                <button v-if="form.is_privacy && loading  && !success" type="button" name="button" class="btn btn-primary">
                    <i class="far fa-circle-notch fa-spin"></i>
                    {{__('__JSON__.Üzenet elküldése')}}
                </button>

                <button v-if="form.is_privacy && !loading && success" type="button" name="button" class="btn btn-success">
                    <i class="fal fa-check"></i>
                    {{__('__JSON__.Üzenet elküldve')}}</button>
            </div>
        </div>


</form>
</div>
</template>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
    props: ['action'],
    inject: ['$validator'],
    components: {
        Loading
    },
    data: function () {
        return {
            elfogadom2: this.__("__JSON__.Elolvastam és elfogadom az <a target=\"_blank\" href=\"/adatkezelesi-nyilatkozat\">adatkezelésben</a> megfogalmazottakat"),
            loading: false,
            success: null,
            error: '',
            radio1: [
                "Új vendéglátóhely nyitását tervezem.",
                "Meglévő eszközparkom fejleszteném.",
                "Specialty kávét vásárolnék."
            ],
            // errors: [],
            form: {
                // first_name: 'jozsi',
                // last_name: 'teszt',
                // phone: '3432423',
                // email: 'taskaijo@gmail.com',
                // message: 'teszt uzenet'

                first_name: '',
                last_name: '',
                phone: '',
                email: '',
                message: ''
            }
        }
    },
    methods: {

        __(text) {
            return (text.replace("__JSON__.", ""))
        },
        send() {
            this.loading = true;
            axios.post('/api/v1/contact', this.form)
                .then(resp => {

                    this.success = resp.data.success;
                    this.loading = false;

                })
                .catch(err => {

                    // this.error = err.data
                    // loading(false)
                });
        },
        onSubmit: function () {
            // this.$emit('input', this.comment);
            // this.$parent.$root.megjegyzes = this.megjegyzes;
        }
    },
    computed: {
        // edited: function() {
        //     this.$root.megjegyzes = this.megjegyzes;
        // }
    }
}
</script>

<style scoped>
.contact-box {
    background: #e5e8ed;
    padding: 5px 20px;

}
</style>
